export default {"src":"/_next/static/media/icon-on-demand-connector.3dce56c1.svg","height":464,"width":547,"blurWidth":0,"blurHeight":0};